export const encodeBookingGroups = (groups = []) => {
  try {
    const payload = groups.map((group, index) => ({
      id: group?.id || `group-${index + 1}`,
      selections: (group?.assignments || group?.selections || [])
        .map((assignment) => ({
          serviceId: Number(assignment.serviceId || assignment.service?.id),
          employeeId: Number(assignment.employeeId || assignment.employee?.id),
        }))
        .filter((selection) => selection.serviceId && selection.employeeId),
    }));

    return window.btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
  } catch (error) {
    console.error("encodeBookingGroups:", error);
    return "";
  }
};

export const decodeBookingGroups = (encodedValue = "") => {
  if (!encodedValue) {
    return [];
  }

  try {
    const decoded = decodeURIComponent(escape(window.atob(encodedValue)));
    const parsed = JSON.parse(decoded);

    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed
      .map((group, index) => ({
        id: group?.id || `group-${index + 1}`,
        selections: Array.isArray(group?.selections)
          ? group.selections
              .map((selection) => ({
                serviceId: Number(selection.serviceId),
                employeeId: Number(selection.employeeId),
              }))
              .filter((selection) => selection.serviceId && selection.employeeId)
          : [],
      }))
      .filter((group) => group.selections.length);
  } catch (error) {
    console.error("decodeBookingGroups:", error);
    return [];
  }
};
